module.exports = __webpack_public_path__ + "static/media/service_02.68b05845.webp";